var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"z-step",on:{"click":_vm.handleStep}},[_c('div',{staticClass:"z-step__step",style:({color: _vm.color, backgroundColor: _vm.bgColor, borderColor: _vm.borderColor})},[_vm._v(_vm._s(_vm.step))]),_c('div',{staticClass:"z-step__label",style:({color: _vm.txtColor})},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }